import KStatsUtil from '../../dw/KStatsUtil';

function eventAbilityPageShow(ability: string, businessId: string, url: string) {
  KStatsUtil.eventPageShow('ability_page', ability, undefined, 'public', businessId, url);
}

function eventAbilityWeixinOpenClick(ability: string, businessId: string, url: string) {
  KStatsUtil.eventButtonClick('weixin_open', ability, undefined, 'public', businessId, url);
}

function eventAbilityCommonOpenClick(
  ability: string,
  businessId: string,
  url: string,
  isJumpBrowser: string,
) {
  KStatsUtil.eventButtonClick(
    'common_open',
    ability,
    undefined,
    'public',
    businessId,
    url,
    isJumpBrowser,
  );
}

function eventDownloadClick(
  ability: string,
  businessId: string,
  url: string,
  platform: string,
  isJumpBrowser: string,
) {
  KStatsUtil.eventButtonClick(
    'common_download',
    ability,
    undefined,
    'public',
    businessId,
    url,
    platform,
    isJumpBrowser,
  );
}

function eventDownloadTrigger(ability: string, businessId: string, chan: string, platform: string) {
  KStatsUtil.eventFuncResult('download', ability, undefined, 'public', businessId, chan, platform);
}

export default {
  eventAbilityPageShow,
  eventAbilityWeixinOpenClick,
  eventAbilityCommonOpenClick,
  eventDownloadClick,
  eventDownloadTrigger,
};
